import { useEffect, useRef } from "react";
import { Card } from "@lya-protect/lya-protect-form-library/dist/UI";
import { SkeletonContent } from "../SkeletonContent";
import styles from "./SkeletonCard.module.scss";

type SkeletonCardProps = {
  className?: string;
  height?: number;
};
export function SkeletonCard({ className, height }: SkeletonCardProps) {
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (divRef.current && height !== undefined) {
      divRef.current.style.setProperty("--skeleton-height", `${height}px`);
    }
  }, [height]);

  return (
    <Card className={className}>
      <div ref={divRef} className={styles.content}>
        <SkeletonContent />
      </div>
    </Card>
  );
}
